import React from 'react';
import styles from './Watermark.module.scss';

function Watermark() {
  return (
    <div className={styles.watermark}>
      <img 
        src={`${process.env.PUBLIC_URL}/shaka-background.png`}
        alt="Shakkii Watermark"
        className={styles.logo}
      />
    </div>
  );
}

export default Watermark;
